import axios from 'axios';

const axiosInstance = axios.create({
    // baseURL: 'http://localhost:8007',
    baseURL: 'https://lifelinemedical-backend.onehexa.in',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor - Attach token to requests
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            const cleanToken = token.replace(/^"(.*)"$/, '$1');
            config.headers.Authorization = `Bearer ${cleanToken}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export default axiosInstance;
// Also export the base URL for use in components that need absolute URLs (e.g., images)
export const BASE_URL = axiosInstance.defaults.baseURL;